import React from 'react';
import { Button } from '../../ui/button';
import { Eye, EyeOff } from 'lucide-react';

export const UserFormModal = ({ formData, setFormData, editingUser, showPassword, setShowPassword, onSubmit, onClose }) => (
  <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div className="bg-gradient-to-br from-black via-orange-950/20 to-black border border-orange-500/30 rounded-lg p-6 max-w-md w-full">
      <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 mb-6">
        {editingUser ? 'Edit User' : 'Add New User'}
      </h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Username *</label>
          <input type="text" value={formData.username}
            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
            className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500"
            required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Email *</label>
          <input type="email" value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500"
            required />
        </div>
        {!editingUser && (
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Password *</label>
            <div className="relative">
              <input type={showPassword ? 'text' : 'password'} value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500 pr-10"
                required minLength="6" />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-1">Minimum 6 characters</p>
          </div>
        )}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Role *</label>
          <select value={formData.role}
            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
            className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500">
            <option value="admin">Admin</option>
            <option value="editor">Editor</option>
            <option value="viewer">Viewer</option>
          </select>
        </div>
        <div className="flex space-x-3 pt-4">
          <Button type="submit" className="flex-1 bg-gradient-to-r from-orange-500 to-green-500 hover:from-orange-600 hover:to-green-600">
            {editingUser ? 'Update User' : 'Create User'}
          </Button>
          <Button type="button" onClick={onClose} className="flex-1 bg-gray-700 hover:bg-gray-600">Cancel</Button>
        </div>
      </form>
    </div>
  </div>
);

export const PasswordResetModal = ({ user, newPassword, setNewPassword, confirmPassword, setConfirmPassword, onSubmit, onClose }) => (
  <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div className="bg-gradient-to-br from-black via-orange-950/20 to-black border border-orange-500/30 rounded-lg p-6 max-w-md w-full">
      <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 mb-6">
        Reset Password
      </h2>
      <p className="text-gray-300 mb-4">
        Reset password for user: <span className="text-orange-400 font-semibold">{user?.username}</span>
      </p>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">New Password *</label>
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500"
            required minLength="6" placeholder="Enter new password" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Confirm Password *</label>
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full px-4 py-2 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:outline-none focus:border-orange-500"
            required minLength="6" placeholder="Confirm new password" />
        </div>
        <p className="text-xs text-gray-400">Minimum 6 characters</p>
        <div className="flex space-x-3 pt-4">
          <Button type="submit" className="flex-1 bg-gradient-to-r from-orange-500 to-green-500 hover:from-orange-600 hover:to-green-600">
            Reset Password
          </Button>
          <Button type="button" onClick={onClose} className="flex-1 bg-gray-700 hover:bg-gray-600">Cancel</Button>
        </div>
      </form>
    </div>
  </div>
);
